import React from "react";
import QRCode from "react-qr-code";
import { showToast } from "../../../components/custom/custom-toast";

interface DriverInfoFormProps {
  username: string;
  password?: string;
  totp_qr_code?: string;
}

const DriverInfoForm: React.FC<DriverInfoFormProps> = ({
  username,
  password,
  totp_qr_code,
}) => {

  const handleCopy = (text: string, type: string) => {
    navigator.clipboard.writeText(text).then(() => {
      showToast({ message: `Đã sao chép ${type}`, type: "success" });
    }).catch(err => {
      console.error('Could not copy text: ', err);
      showToast({ message: `Sao chép thất bại`, type: "error" });
    });
  };

  return (
    <div className="mt-6 space-y-6 text-center">
      {/* QR Code */}
      {totp_qr_code && (
        <div className="flex flex-col items-center gap-4 p-4 border rounded-xl bg-gray-50">
          <h4 className="font-semibold text-gray-700">Mã xác thực (2FA)</h4>
          <p className="text-sm text-gray-500">Quét mã QR này bằng ứng dụng xác thực của bạn (ví dụ: Google Authenticator).</p>
          <div style={{ background: 'white', padding: '16px' }}>
            <QRCode value={totp_qr_code} size={200} />
          </div>
        </div>
      )}

      {/* Credentials */}
      <div className="space-y-4">
        <div className="flex justify-between items-center p-3 border rounded-xl">
          <div className="text-left">
            <label className="block text-sm font-medium text-slate-500">Tên đăng nhập</label>
            <span className="font-mono text-lg text-slate-800">{username}</span>
          </div>
          <button
            onClick={() => handleCopy(username, "tên đăng nhập")}
            className="rounded-lg bg-slate-100 px-3 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-200"
          >
            Sao chép
          </button>
        </div>

        {password && (
          <div className="flex justify-between items-center p-3 border rounded-xl">
            <div className="text-left">
              <label className="block text-sm font-medium text-slate-500">Mật khẩu</label>
              <span className="font-mono text-lg text-slate-800">{password}</span>
            </div>
            <button
              onClick={() => handleCopy(password, "mật khẩu")}
              className="rounded-lg bg-slate-100 px-3 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-200"
            >
              Sao chép
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DriverInfoForm;